import { styled } from "styled-components";
import { getBounds } from "../../utils/calculations";

const Root = styled.img`
  left: ${props => props.$x}px;
  position: absolute;
  top: ${props => props.$y}px;
  translate: -50% -50%;
  width: 192px;
`;

// The star is in the middle
function getCoord(bounds) {
  const x = 0;
  const y = 0;

  return { x, y };
}

function Star({ store, zoom }) {
  const bounds = getBounds(store.state.system.waypoints);
  const coord = getCoord(bounds);

  return (
    <Root $x={coord.x} $y={coord.y} $size={10} src={`../images/stars/${store.state.system.type}.png`} />
  );
}

export default Star;
